import styles from './PageSkeleton.module.scss'

/**
 * Suspense fallback used while a lazy-loaded page chunk is downloading.
 * V1 is intentionally minimal — a quiet pulsing block in the content
 * area. Full per-page skeletons (TaskCard / RequestCard skeletons) land
 * in Phase 7.1.
 */
export function PageSkeleton() {
  return (
    <div className={styles.root} aria-busy="true" aria-live="polite">
      <span className={styles.srOnly}>Loading page</span>
      <div className={styles.block} />
    </div>
  )
}
